/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* istanbul ignore file */

//  @ts-nocheck
/* eslint-disable no-unused-vars */
import Dropdown from '@react/react-spectrum/Dropdown';
import OverlayTrigger from './LanguageSwitcherOverlayTrigger';
import {Menu} from '@react/react-spectrum/Menu';
import filterDOMProps from '@react/react-spectrum/utils/filterDOMProps';
import React from 'react';

/* eslint-enable no-unused-vars */

export default class LanguageSwitcherDropdown extends Dropdown {
	render() {
		const {closeOnSelect, trigger, onLongClick, ...otherProps} = this.props;
		const children = React.Children.toArray(this.props.children);
		const triggerChild: any = children.find((c: any) => c.props.dropdownTrigger) || children[0];
		const triggerId = triggerChild.props.id || `${this.dropdownId}-trigger`;
		const menu: any = children.find((c: any) => c.props.dropdownMenu || c.type === Menu) || children[1];
		const menuId = menu.props.id || `${this.dropdownId}-menu`;
		delete otherProps.onOpen;
		delete otherProps.onClose;
		delete otherProps.onClick;

		return (
			<div {...filterDOMProps(otherProps)}>
				{children.map((child, index) => {
					if (child === triggerChild) {
						return (
							<OverlayTrigger
								target={this}
								trigger={trigger}
								placement='top left'
								ref={t => (this.overlayTrigger = t)}
								onLongClick={onLongClick}
								onClick={this.onClick}
								onShow={this.onOpen}
								closeOnSelect={closeOnSelect}
								key={index}
								onHide={this.onClose}
								flip
								delayHide={0}
							>
								{React.cloneElement(triggerChild, {
									id: triggerId,
									'aria-haspopup': triggerChild.props['aria-haspopup'] || 'true',
									'aria-expanded': this.state.open || null,
									'aria-controls': this.state.open ? menuId : null,
									ref: (node) => {
										this.triggerRef = node;
										const {ref} = triggerChild;
										if (typeof ref === 'function') {
											ref(node);
										}
									},
								})}
								{React.cloneElement(menu, {
									id: menuId,
									'aria-labelledby': menu.props['aria-labelledby'] || triggerId,
									onClose: this.onMenuClose,
									onSelect: this.onSelect,
									autoFocus: true,
								})}
							</OverlayTrigger>
						);
					}
					else if (child !== menu) {
						return child;
					}
					return null;
				})}
			</div>
		);
	}
}
